import { IAction } from "store";
import { DealAction } from "../../actions";
import { IRound } from "../../types";
import { reducer } from "../index";

reducer.createHandler(DealAction.CreateRoundSuccess, (state, { payload }: IAction<IRound>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    deal: {
      ...state.dealModule.deal,
      rounds: [...state.dealModule.deal.rounds, payload]
    }
  }
}));

reducer.createHandler(DealAction.DeleteRoundSuccess, (state, { payload }: IAction<IRound>) => {
  return {
    ...state,
    dealModule: {
      ...state.dealModule,
      deal: {
        ...state.dealModule.deal,
        rounds: [...state.dealModule.deal.rounds].filter((round: IRound) => round.id !== payload.id)
      }
    }
  };
});

reducer.createHandler(DealAction.UpdateRoundSuccess, (state, { payload }: IAction<IRound>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    deal: {
      ...state.dealModule.deal,
      rounds: [...state.dealModule.deal.rounds].map((round: IRound) => {
        if (round.id === payload.id) {
          return {
            ...round,
            ...payload
          };
        }
        return round;
      })
    }
  }
}));

reducer.createHandler(DealAction.GetRoundsSuccess, (state, { payload }: IAction<IRound[]>) => ({
  ...state,
  dealModule: {
    ...state.dealModule,
    deal: {
      ...state.dealModule.deal,
      rounds: payload
    }
  }
}));
